import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { createContext } from 'react';
import { getEnv } from 'utils';

const defaultStripePromise = loadStripe(getEnv('STRIPE_API_KEY'));
const StripeContext = createContext();

export function StripeProvider({ children }) {
  return (
    <StripeContext.Provider value={defaultStripePromise}>
      <Elements stripe={defaultStripePromise}>{children}</Elements>
    </StripeContext.Provider>
  );
}
